export interface Banner {
  id: number;
  title: string;
  sortOrder: number;
  isActive: boolean;
  linkUrl: string;
  image: string;
  description: string;
  locale?: string;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyBanner = (): Banner => ({
  id: 0,
  title: '',
  sortOrder: 0,
  isActive: true,
  linkUrl: '',
  image: '',
  description: '',
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const bannerFromResponse = (responseData: any): Banner => ({
  id: responseData.id,
  title: responseData.title,
  sortOrder: responseData.sort_order,
  isActive: responseData.is_active,
  linkUrl: responseData.link_url,
  image: responseData.image,
  description: responseData.description,
  locale: responseData.locale,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const bannerToUpsertRequest = (banner: Banner) => ({
  title: banner.title,
  sort_order: banner.sortOrder,
  description: banner.description,
  link_url: banner.linkUrl,
  is_active: banner.isActive,
  locale: banner.locale,
});
